// Вход и привязка через Telegram Mini App (подписанный initData).
import axios from 'axios';
import { tt } from '../i18n';
import { showToast } from '../components/Toast';
import config from '../config';
import { isTelegramWebApp, getInitData, langFromSite } from './telegramWebApp';

let staffHintShown = false;

// Автовход. Возвращает: user | { notLinked:true, botUsername } | { staffDisabled:true } | null (вне Telegram, 401/503/сеть).
export const telegramAutoLogin = async () => {
  if (!isTelegramWebApp()) return null;
  try {
    const response = await axios.post(
      `${config.apiUrl}/api/auth/telegram`,
      { initData: getInitData() },
      { withCredentials: true }
    );
    return response.data?.user || null;
  } catch (error) {
    const data = error?.response?.data;
    if (error?.response?.status === 404 && data?.code === 'telegram_not_linked') {
      return { notLinked: true, botUsername: data.botUsername || null };
    }
    if (error?.response?.status === 403 && data?.code === 'telegram_login_disabled_for_staff') {
      if (!staffHintShown) {
        staffHintShown = true;
        try { showToast(tt('Сотрудникам вход через Telegram недоступен — войдите по паролю'), 'info', 6000); } catch (e) { /* ignore */ }
      }
      return { staffDisabled: true };
    }
    return null;
  }
};

// Привязка текущего пользователя внутри мини-приложения.
// Возвращает { ok, status, conflict } и не бросает исключений.
export const linkTelegramWebApp = async () => {
  if (!isTelegramWebApp()) return { ok: false, skipped: true };
  try {
    const response = await axios.post(
      `${config.apiUrl}/api/telegram/link-webapp`,
      { initData: getInitData(), lang: langFromSite() },
      { withCredentials: true }
    );
    return { ok: true, status: 200, settings: response.data };
  } catch (error) {
    const status = error?.response?.status || 0;
    return { ok: false, status, conflict: status === 409, code: error?.response?.data?.code || null };
  }
};
